/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export enum TaskHeaders {
  RESET_TAG_SIGN_AHEAD_DOCUMENTS = 'Reset Tags In Sign Ahead Documents',
  SELECT_RON_PROVIDER = 'Select RON Platform',
  SHARE_CLOSING_WITH_ATTORNEY = 'Share closing package with attorney',
  TAG_ESIGN_DOCUMENTS = 'Tag eSign Documents',
  TAG_SIGN_AHEAD_DOCUMENTS = 'Tag Sign Ahead Documents',
  UNSIGNED_ESIGN_DOCUMENTS = 'Missing borrower signature on eSign documents',
  UPLOAD_ADDITIONAL_DOCUMENTS = 'Upload Additional Documents',
  UPLOAD_CLOSING_PACKAGE = 'Upload Completed (Ink Signed) Closing Package',
  UPLOAD_DAY_OF_DOCUMENTS = 'Upload Day Of Docs',
  UPLOAD_ESIGN_DOCUMENTS = 'Upload eSign Documents',
  UPLOAD_SIGN_AHEAD_DOCUMENTS = 'Upload Sign Ahead Documents',
  UPLOAD_TITLE_DOCUMENTS = 'Upload Title Documents',
  UPLOAD_WET_SIGN_DOCUMENTS = 'Upload Wet Sign Documents',
}
